<generic-page
  [image]="imageName$ | async"
  [hidePortalMenu]="true"
  [showAppHeader]="false"
  [columnLayout]="false"
  >
  <div class="container">
    <mat-card>
      <div class="property-address">{{ address$ | async }}</div>

      <div class="header">
        <span>Congratulations!</span>
      </div>

      <div class="description">
        <span>
          Your property is qualified for Ygrene financing.
          @if (!(isMobile$ | async)) {
            <br />
          }
          Enter your projected project cost to calculate your estimated monthly cost.
        </span>
      </div>

      <form [formGroup]="costForm" (ngSubmit)="submit()">
        <mat-form-field floatLabel="always">
          <mat-label>Project cost amount (Min $5,000)</mat-label>
          <fa-icon matPrefix [icon]="['fas', 'dollar-sign']"></fa-icon>
          <input
            matInput
            [placeholder]="estimatedCost$ | async | currency : 'USD' : '' : '1.0-0'"
            [mask]="moneyMaskWithoutDecimal"
            numberInput
            formControlName="estimated_cost"
            [separatorLimit]="maskConfig.separatorLimit"
            autofocus
            />

          @if (costForm.get('estimated_cost').hasError('required')) {
            <mat-error
              >Please enter a valid project cost</mat-error
              >
            }

            @if (costForm.get('estimated_cost').hasError('min')) {
              <mat-error>
                Project cost must be a minimum of $5000
              </mat-error>
            }

            @if (costForm.get('estimated_cost').hasError('max')) {
              <mat-error>
                Project cost must be a maximum of $100,000,000
              </mat-error>
            }
          </mat-form-field>

          <div class="button-wrapper">
            <page-button
              [config]="{ arrow: false, rank: 'secondary-grey' }"
              [loading]="isLoading$ | async"
              >{{ (monthlyCosts$ | async)?.length ? 'Recalculate' : 'Calculate' }}</page-button
              >
            </div>
          </form>

          <div class="terms-container">
            @for (costInfo of monthlyCosts$ | async; track costInfo) {
              <div class="term-card">
                <span class="term-year">{{ costInfo.term }} years</span>
                <span class="term-amount"
                  >{{ costInfo.monthly_cost | roundUp | currency : 'USD' : 'symbol' : '1.0-0' }}/mo</span
                  >
                  <span class="term-percent">{{
                    costInfo.interest_rate / 100 | percent : '1.1-3' : 'en-US'
                  }}</span>
                </div>
              }
            </div>

            @if ((monthlyCosts$ | async)?.length > 0) {
              <div class="disclaimer-section">
                <p class="sub-heading">Important information:</p>
                <ul>
                  <li>
                    * Amount shown is for informational purposes. Term limitations and other conditions will
                    apply.
                  </li>
                  <li>* Property qualification and financing approval are subject to underwriting</li>
                  <li>* Includes program fees and interest</li>
                </ul>
              </div>
            }

            @if (isDesktop$ | async) {
              <div class="button-wrapper">
                <page-button (clicked)="navigate()">Apply Now</page-button>
                <page-button [config]="{ rank: 'secondary' }" (clicked)="close()">Cancel</page-button>
              </div>
            }
          </mat-card>
        </div>
      </generic-page>

      @if (!(isDesktop$ | async)) {
        <div class="footer-wrapper" noShadowOnBottom>
          <page-footer
            [primary]="{ label: 'Apply Now', arrow: 'right' }"
            [primCenteredIfNoSecondary]="true"
            (primaryClicked)="navigate()"
            [secondary]="{ label: 'Cancel', arrow: 'left' }"
            (secondaryClicked)="close()"
            [valid]="true"
          ></page-footer>
        </div>
      }
